// Storefront Cookie Consent UI
(() => {
  const init = () => {
    const cookieBanner = document.querySelector('[data-cookie-banner]') || document.querySelector('[data-cookie-demo]');
    const cookieOpener = document.querySelector('[data-cookie-open]') || document.querySelector('[data-cookie-demo-open]');
    if (!cookieBanner) return;

    const storageKey = 'naturium-cookie-consent-choice';

    const measure = () => {
      const height = cookieBanner.hidden ? 0 : cookieBanner.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--cookie-banner-height', `${height}px`);
      document.documentElement.style.setProperty('--cookie-demo-height', `${height}px`);
    };

    const show = () => {
      cookieBanner.hidden = false;
      document.body.classList.add('cookie-banner-visible');
      document.body.classList.add('cookie-demo-visible');
      if (cookieOpener) {
        cookieOpener.setAttribute('aria-expanded', 'true');
        cookieOpener.hidden = true;
      }
      measure();
    };

    const dismiss = () => {
      const returnFocus = cookieBanner.contains(document.activeElement);
      cookieBanner.hidden = true;
      document.body.classList.remove('cookie-banner-visible');
      document.body.classList.remove('cookie-demo-visible');

      if (cookieOpener) {
        cookieOpener.setAttribute('aria-expanded', 'false');
        cookieOpener.hidden = true;
      }

      // This is a decorative notice: any explicit dismissal remembers that
      // the visitor has seen it, without recording a consent decision.
      try {
        localStorage.setItem(storageKey, 'dismissed');
      } catch {
        /* Persistent storage unavailable */
      }

      measure();

      if (returnFocus) {
        const main = document.querySelector('#MainContent');
        if (main) main.focus({ preventScroll: true });
      }
    };

    // Attach dismiss handler to all action buttons
    const actionButtons = cookieBanner.querySelectorAll('[data-cookie-action], [data-cookie-demo-dismiss]');
    actionButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        dismiss();
      });
    });

    // Escape key closes banner
    cookieBanner.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        dismiss();
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(measure).observe(cookieBanner);
    }

    let hasChoice = false;
    try {
      hasChoice = Boolean(localStorage.getItem(storageKey));
    } catch {
      hasChoice = false;
    }

    if (hasChoice) {
      cookieBanner.hidden = true;
      document.body.classList.remove('cookie-banner-visible');
      document.body.classList.remove('cookie-demo-visible');
      if (cookieOpener) cookieOpener.hidden = true;
      measure();
    } else {
      show();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
